var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { AbortableClearEventListener, AbortableSubmitEventListener, ClearEventListener, SubmitEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { createAbort } from '@philips-internal/oswald-ui-utils';
import { addSymbolToRecord } from './filter-symbol.js';
class FilterAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onBeforeCancel = new AbortableSubmitEventListener();
        /** @event */
        this.onBeforeClear = new AbortableClearEventListener();
        /** @event */
        this.onBeforeSubmit = new AbortableSubmitEventListener();
        /** @event */
        this.onCancel = new SubmitEventListener();
        /** @event */
        this.onClear = new ClearEventListener();
        /** @event */
        this.onSubmit = new SubmitEventListener();
    }
    /**
     * Returns the filter title.
     */
    getTitle() {
        return this.state.title;
    }
    /**
     * Sets the filter title.
     *
     * @param title - The filter title.
     */
    setTitle(title) {
        this.setState({ title });
    }
    /**
     * Returns the filter data.
     */
    getData() {
        return this.state.data;
    }
    /**
     * Sets the filter data.
     *
     * @param data - The filter data.
     */
    setData(data) {
        this.setState({ data });
    }
    /**
     * Returns the filter density.
     */
    getDensity() {
        return this.state.density;
    }
    /**
     * Sets the filter density.
     *
     * @param density - The filter density.
     */
    setDensity(density) {
        this.setState({ density });
    }
    /**
     * Returns the filter modal properties.
     */
    getModalProps() {
        return this.state.modalProps;
    }
    /**
     * Sets the filter modal properties.
     *
     * @param modalProps - The filter modal properties.
     */
    setModalProps(modalProps) {
        this.setState({ modalProps });
    }
    /**
     * Returns the filter record mapper.
     */
    getRecordMapper() {
        return this.state.recordMapper;
    }
    /**
     * Sets the filter record mapper.
     *
     * @param recordMapper - The filter record mapper.
     */
    setRecordMapper(recordMapper) {
        this.setState({ recordMapper });
    }
    /**
     * Returns the filter record.
     */
    getRecord() {
        return this.state.record;
    }
    /**
     * Triggers the filter submit event.
     */
    submit() {
        const abort = createAbort();
        const record = this.getRecord();
        this.onBeforeSubmit.fire({ abort, record });
        void abort.promise.then(aborted => {
            if (aborted)
                return;
            this.onSubmit.fire({ record });
        });
    }
    /**
     * Triggers the filter cancel event.
     */
    cancel() {
        const abort = createAbort();
        const record = this.getRecord();
        this.onBeforeCancel.fire({ abort, record });
        void abort.promise.then(aborted => {
            if (aborted)
                return;
            this.onCancel.fire({ record });
        });
    }
    /**
     * Clears the filter record.
     */
    clear() {
        this.setState({ record: {} });
        this.submit();
    }
    /**
     * Opens the filter modal.
     */
    open() {
        this.setState({ open: true });
    }
    /**
     * Resets the filter data to default.
     */
    resetDefaultData() {
        const record = addSymbolToRecord(this.state.data);
        this.setState({ record });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], FilterAPI.prototype, "onBeforeCancel", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], FilterAPI.prototype, "onBeforeClear", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], FilterAPI.prototype, "onBeforeSubmit", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], FilterAPI.prototype, "onCancel", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], FilterAPI.prototype, "onClear", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], FilterAPI.prototype, "onSubmit", void 0);
export { FilterAPI, };
//# sourceMappingURL=filter-api.js.map